import type { GuardrailCategory } from '@terra/shared-contracts-applications';

export const GUARDRAIL_CATEGORY_FILTER_ID = 'guardrailCategory';
export const ALL_GUARDRAIL_CATEGORIES = 'all';

type FilterableGuardrail = {
  name: string;
  category: GuardrailCategory;
};

export const filterGuardrails = <TGuardrail extends FilterableGuardrail>({
  guardrails,
  search,
  category,
}: {
  guardrails: readonly TGuardrail[];
  search: string;
  category: string;
}): TGuardrail[] => {
  const needle = search.trim().toLowerCase();

  return guardrails.filter(
    (guardrail) =>
      (category === ALL_GUARDRAIL_CATEGORIES ||
        guardrail.category === category) &&
      (!needle || guardrail.name.toLowerCase().includes(needle)),
  );
};

export const toggleExpandedId = ({
  ids,
  id,
}: {
  ids: ReadonlySet<string>;
  id: string;
}): ReadonlySet<string> =>
  new Set(
    ids.has(id) ? [...ids].filter((existing) => existing !== id) : [...ids, id],
  );
